import React, { useState, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Toggle from './toggle';
import ListBox from './list_box';

const FilterModal = ({ onClose, onApply }) => {
    const initialFilters = {
        'COGNOME': true,
        'NOME': true,
        'CITTADINANZA': true,
        'LIVELLO ISTRUZIONE': true,
        'TITOLO DI SOGGIORNO': true, 
        'NUMERO PERMESSO DI SOGGIORNO': true,
        'MOTIVO TITOLO DI SOGGIORNO': true,
        'SCADENZA TITOLO DI SOGGIORNO': true,
        'QUESTURA RILASCIO TITOLO DI SOGGIORNO': true,
        'EMAIL': true,
        'SESSO': true,
        'DATA DI NASCITA': true,
        'LUOGO DI NASCITA': true,
        'COMUNE DOMICILIO': true,
        'INDIRIZZO DOMICILIO': true,
        'CAP DOMICILIO': true,
        'MANSIONE': true,
        'LIVELLO': true,
        'SEDE DI LAVORO': true,
        'IBAN': true,
        'STATO CONTRATTO': true,
        'DATA INIZIO': true,
        'DATA FINE': true,
        'ENTE PREVIDENZIALE': true,
        'PAT INAIL': true,
        'SOCIO LAVORATORE': true,
        'LAVORATORE IN MOBILITÀ': true,
        'QUALIFICA PROFESSIONALE ISTAT': true,
        'TIPO ORARIO LAVORO': true,
        'ORE SETTIMANALI': true,
        'TIPOLOGIA CONTRATTUALE': true,
        'LAVORO STAGIONALE': true,
        'ASSUNZIONE OBBLIGATORIA': true,
        'TIPO ASSUNZIONE OBBLIGATORIA': true,
        'C.C.N.L.': true,
        'LIVELLO DI INQUADRAMENTO': true,
        'RETRIBUZIONE': true,
        'LAVORO IN AGRICOLTURA': true,
    };

    const options = [
        { name: 'Tutti', value: 'all' },
        { name: 'Solo attivi', value: 'active' },
        { name: 'Solo non attivi', value: 'inactive' },
    ];

    const [selectedFilters, setSelectedFilters] = useState(initialFilters);
    const [format, setFormat] = useState('CSV');
    const [selectedOption, setSelectedOption] = useState('CSV');
    const [contractStatus, setContractStatus] = useState(options[0]);

    const filters = [
        { name: 'COGNOME', label: 'Cognome' },
        { name: 'NOME', label: 'Nome' },
        { name: 'CITTADINANZA', label: 'Cittadinanza' },
        { name: 'LIVELLO ISTRUZIONE', label: 'Livello Istruzione' },
        { name: 'TITOLO DI SOGGIORNO', label: 'Titolo di Soggiorno' },
        { name: 'NUMERO PERMESSO DI SOGGIORNO', label: 'Numero Permesso di Soggiorno' },
        { name: 'MOTIVO TITOLO DI SOGGIORNO', label: 'Motivo Titolo di Soggiorno' },
        { name: 'SCADENZA TITOLO DI SOGGIORNO', label: 'Scadenza Titolo di Soggiorno' },
        { name: 'QUESTURA RILASCIO TITOLO DI SOGGIORNO', label: 'Questura Rilascio Titolo di Soggiorno' },
        { name: 'EMAIL', label: 'Email' },
        { name: 'SESSO', label: 'Sesso' },
        { name: 'DATA DI NASCITA', label: 'Data di Nascita' },
        { name: 'LUOGO DI NASCITA', label: 'Luogo di Nascita' },
        { name: 'COMUNE DOMICILIO', label: 'Comune Domicilio' },
        { name: 'INDIRIZZO DOMICILIO', label: 'Indirizzo Domicilio' },
        { name: 'CAP DOMICILIO', label: 'CAP Domicilio' },
        { name: 'LIVELLO', label: 'Livello' },
        { name: 'SEDE DI LAVORO', label: 'Sede di Lavoro' },
        { name: 'IBAN', label: 'IBAN' },
        { name: 'STATO CONTRATTO', label: 'Stato Contratto' },
        { name: 'DATA INIZIO', label: 'Data Inizio' },
        { name: 'DATA FINE', label: 'Data Fine' },
        { name: 'ENTE PREVIDENZIALE', label: 'Ente Previdenziale' },
        { name: 'PAT INAIL', label: 'PAT Inail' },
        { name: 'SOCIO LAVORATORE', label: 'Socio Lavoratore' },
        { name: 'LAVORATORE IN MOBILITÀ', label: 'Lavoratore in Mobilità' },
        { name: 'QUALIFICA PROFESSIONALE ISTAT', label: 'Qualifica Professionale ISTAT' },
        { name: 'TIPO ORARIO LAVORO', label: 'Tipo Orario Lavoro' },
        { name: 'ORE SETTIMANALI', label: 'Ore Settimanali' },
        { name: 'TIPOLOGIA CONTRATTUALE', label: 'Tipologia Contrattuale' },
        { name: 'LAVORO STAGIONALE', label: 'Lavoro Stagionale' },
        { name: 'ASSUNZIONE OBBLIGATORIA', label: 'Assunzione Obbligatoria' },
        { name: 'TIPO ASSUNZIONE OBBLIGATORIA', label: 'Tipo Assunzione Obbligatoria' },
        { name: 'C.C.N.L.', label: 'C.C.N.L.' },
        { name: 'LIVELLO DI INQUADRAMENTO', label: 'Livello di Inquadramento' },
        { name: 'RETRIBUZIONE', label: 'Retribuzione' },
        { name: 'LAVORO IN AGRICOLTURA', label: 'Lavoro in Agricoltura' },
    ];

    const handleToggleChange = (selectedOption) => {       
        setSelectedOption(selectedOption);
        setFormat(selectedOption);
    };

    const handleFilterChange = (filterName) => {
        setSelectedFilters(prevState => ({
            ...prevState,
            [filterName]: !prevState[filterName],
        }));
    };

    const handleSelectAll = (e) => {
        const checked = e.target.checked;
        setSelectedFilters(
            filters.reduce((acc, filter) => {
                acc[filter.name] = checked;
                return acc;
            }, {})
        );
    };

    const handleSubmit = () => {
        const activeFilters = Object.keys(selectedFilters).filter(key => selectedFilters[key]);
        onApply({
            filters: activeFilters,
            format: selectedOption,
            contractStatus,
        });       
        onClose();
    };

    return (
        <Transition.Root show={true} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 z-30 overflow-y-auto top-10 max-h-[80vh]" onClose={() => {}}>
                <div className="flex items-start justify-center min-h-screen px-4 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="inline-block bg-white rounded-lg p-0 text-left overflow-hidden shadow-xl transform transition-all w-2/3">
                            <div className='sticky top-0 z-20'>
                                <h1 className='text-center text-lg bg-indigo-100 p-2 font-semibold text-indigo-800'>Esporta Dati</h1>
                            </div>
                            <div className='py-4 px-8 max-h-[80vh] overflow-y-auto'>
                                <h2 className='text-sm font-semibold text-gray-900'>Seleziona il formato del file</h2>
                                <div className='justify-center flex'>
                                    <Toggle
                                        color="indigo"
                                        gradeBgColor="600"
                                        optionLeft="CSV"
                                        optionRight="EXCEL"
                                        selectedOption={selectedOption}
                                        onChange={handleToggleChange}
                                    />
                                </div>

                                <h2 className='text-sm font-semibold text-gray-900'>Seleziona lo stato del contratto</h2>
                                <div className='mb-6'>
                                    <ListBox
                                        options={options}
                                        defaultValue={options[0]}
                                        onChange={(value) => setContractStatus(value.value)}
                                        className='border-gray-200'
                                    />
                                </div>

                                <h2 className='text-sm font-semibold text-gray-900 pb-2'>Seleziona i filtri</h2>
                                <div className='border border-gray-200 rounded-md shadow-md overflow-y-auto max-h-60'>
                                    <div className="grid grid-cols-3 gap-2 my-3 pl-3">
                                        <label>
                                            <input
                                                type="checkbox"
                                                onChange={handleSelectAll}
                                                checked={Object.values(selectedFilters).every(Boolean)}
                                                className='rounded border-gray-300 text-indigo-600 focus:ring-indigo-600'
                                            />
                                            <span className='text-sm font-semibold text-gray-900 pl-2'>Tutti</span>
                                        </label>
                                        {filters.map((filter) => (
                                            <div key={filter.name}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedFilters[filter.name]}
                                                        onChange={() => handleFilterChange(filter.name)}
                                                        className='rounded border-gray-300 text-indigo-600 focus:ring-indigo-600'
                                                    />
                                                    <span className='text-sm font-semibold text-gray-900 pl-2'>{filter.label}</span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className='flex justify-center items-center mt-4 mb-2'>
                                    <button 
                                        onClick={handleSubmit}
                                        className='inline-flex items-center justify-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 me-3 w-20'
                                    >
                                        Esporta
                                    </button>
                                    <button 
                                        onClick={onClose}
                                        className='border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600 w-20'
                                    >
                                        Chiudi
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default FilterModal;
